// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { action, makeObservable, observable } from 'mobx';
import { PzPublisher, PzTerms, PzUserSignUp } from 'models/pz';
// data
import { PzSource } from 'sources/pz-source';
import { BFFAxiosResponse, Progress } from 'src/models/common';

export class PzStore extends Store {
  public terms = '';
  public termsId: string;
  public termsState: string; // 'pending', 'done' or 'error'
  public enrolling: boolean;
  public bulkAssignProgress: Progress = 'inactive';

  public pzPublisher: PzPublisher;

  constructor(private pzSource: PzSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);

    makeObservable(this, {
      terms: observable,
      termsId: observable,
      termsState: observable,
      bulkAssignProgress: observable,
      termsFetchSuccess: action,
      termsFetchFailure: action,
      pzPublisher: observable,
      pzPublisherFetchSuccess: action,
      enrolling: observable,
      setEnrolling: action,
    });
  }

  public hydrate(data: SerializedData): void {
    if (data.pzSource) {
      Object.assign(this.pzSource, data.pzSource);
    }

    delete data.pzSource;
    Object.assign(this, data);
  }

  public async fetchTerms(country: string, locale: string) {
    this.terms = '';
    this.termsState = 'pending';

    try {
      const newTerms = await this.pzSource.getPartnerizeTerms(locale, country);
      this.termsFetchSuccess(newTerms);
    } catch (e) {
      this.termsFetchFailure(e);
    }
  }

  public termsFetchSuccess = (terms: PzTerms) => {
    this.terms = terms.terms_and_conditions;
    this.termsId = terms.ref_terms_and_conditions_locale_id;
    this.termsState = 'done';
  };

  public termsFetchFailure = (error) => {
    this.termsState = 'error';
  };

  public setEnrolling = (isEnrolling: boolean) => {
    this.enrolling = isEnrolling;
  };

  public async fetchPartner(token: string): Promise<PzPublisher> {
    return await this.pzSource.getPartner(token);
  }

  public async getExpediaGroupTerms(locale: string, country: string) {
    return await this.pzSource.getExpediaGroupTerms(locale, country);
  }

  public createUser(programName: string, user: PzUserSignUp) {
    return this.pzSource.createUser(programName, user);
  }

  public async assignBulkCampaignsAsBrand(
    programNames: string[],
    partnerId: string,
    userId: string,
    locale: string,
  ): Promise<BFFAxiosResponse> {
    this.bulkAssignProgress = 'pending';
    const res = await this.pzSource.assignBulkCampaignsAsBrand(programNames, partnerId, userId, locale);
    this.bulkAssignProgress = 'done';

    return res;
  }

  public assignCampaignAsBrand(programName: string, partnerId: string, campaignTermsId: string) {
    return this.pzSource.assignCampaign(programName, partnerId, campaignTermsId);
  }

  public assignCampaignAsPartner(programName: string, partnerId: string, campaignTermsId: string, accessToken: string) {
    return this.pzSource.assignCampaignAsPartner(programName, partnerId, campaignTermsId, accessToken);
  }

  public async fetchPzUser(publisherId: string) {
    this.pzPublisher = {} as PzPublisher;

    try {
      const pzPublisher = await this.pzSource.getPublisher(publisherId);
      this.pzPublisherFetchSuccess(pzPublisher.body.publisher);
    } catch (e) {
      throw new Error('Failed fetch Pz user info');
    }
  }

  public pzPublisherFetchSuccess(pzPublisher: PzPublisher) {
    this.pzPublisher = pzPublisher;
  }
}
